export default {
  'paymentDetails.header': 'Payment Details'
};
